import { TRUSTED_BY } from "@/data/content";
import { Landmark, Building, Factory, GraduationCap, Cross, Store } from "lucide-react";

const icons = [Landmark, Building, Factory, GraduationCap, Cross, Store];

const TrustedBy = () => {
  const items = [...TRUSTED_BY, ...TRUSTED_BY];
  return (
    <section className="py-12 border-y border-slate-100 bg-brand-grey/60 overflow-hidden" data-testid="trusted-by">
      <div className="max-shell mx-auto px-4 md:px-8 lg:px-12">
        <p className="text-center text-sm font-bold uppercase tracking-[0.2em] text-slate-400 mb-8">
          Trusted across sectors
        </p>
      </div>
      <div className="relative">
        <div className="flex gap-14 w-max animate-marquee">
          {items.map((label, i) => {
            const Icon = icons[i % icons.length];
            return (
              <div
                key={`${label}-${i}`}
                className="flex items-center gap-2.5 text-slate-400 hover:text-brand-green transition-colors grayscale hover:grayscale-0"
                data-testid={`trusted-logo-${i}`}
              >
                <Icon className="h-6 w-6" />
                <span className="text-lg font-bold whitespace-nowrap">{label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustedBy;
